// FileReader i stedet for Blob.text() så det virker i alle nettlesere og i jsdom.
const lesBlobSomTekst = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const leser = new FileReader();
    leser.onload = () => resolve(String(leser.result));
    leser.onerror = () => reject(leser.error);
    leser.readAsText(blob);
  });

export const lesFeilmelding = async (err: any, reserve: string): Promise<string> => {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await lesBlobSomTekst(data)).error || reserve;
    } catch {
      return reserve;
    }
  }
  return data?.error || reserve;
};

/** Lenken fjernes fra DOM straks, men objekt-URL-en frigis først etter dette, så nedlastingen ikke avbrytes. */
export const FRIGI_URL_ETTER_MS = 1000;

/** Laster ned en blob som fil via en midlertidig <a download>, og frigir objekt-URL-en litt etterpå. */
export const lastNedBlob = (blob: Blob, filnavn: string): void => {
  const url = URL.createObjectURL(blob);
  try {
    const lenke = document.createElement('a');
    lenke.href = url;
    lenke.download = filnavn;
    document.body.appendChild(lenke);
    lenke.click();
    document.body.removeChild(lenke);
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), FRIGI_URL_ETTER_MS);
  }
};

const DAG_MS = 24 * 60 * 60 * 1000;
export const STANDARD_DAGER = 90;
const tilDatoStreng = (dato: Date): string => dato.toISOString().slice(0, 10);

/**
 * Én effektiv periode som sendes både til lista og eksporten (speiler adminAudit/eksport.js):
 * tom `til` blir i dag, tom `fra` blir `til` minus 90 dager.
 */
export const effektivPeriode = (fra: string, til: string): { fra: string; til: string } => {
  const effTil = til || tilDatoStreng(new Date());
  const effFra = fra || tilDatoStreng(new Date(Date.parse(effTil) - STANDARD_DAGER * DAG_MS));
  return { fra: effFra, til: effTil };
};
